import { Component, Prop, Vue } from 'vue-property-decorator';
import { AvatarSelectionOptions, UserDTO } from '@/models';
import { getUserDisplayInfo } from '@/services';
import PopupMenu from '@/components/common/popup-menu/PopupMenu.vue';
import UserInformation from '@/components/common/user-information/UserInformation.vue';

@Component({
  components: { PopupMenu, UserInformation }
})
export default class AddAdminForm extends Vue {
  private formElementProps = {
    outlined: true,
    dense: true,
    required: true
  };

  $refs!: {
    menuRef: HTMLFormElement;
    formRef: HTMLFormElement;
  };

  @Prop({ default: () => [] }) users: UserDTO[];
  @Prop({ default: () => [] }) admins: UserDTO[];

  private userId = -1 as number;

  private ruleOptions = {
    employee: [
      (v: number) => (!!v && v >= 1) || `Employee is required`,
      (v: number) => (v && !this.checkUserExistInAdminList(v)) || 'Employee was an Admin'
    ]
  };

  buildUserOptions(): AvatarSelectionOptions {
    return this.users
      .filter(user => user.id && user.code)
      .map(user => ({
        avatarUrl: user.avatarUrl,
        code: user.code,
        fullName: user.fullName,
        text: getUserDisplayInfo(user),
        value: user.id
      }));
  }

  checkUserExistInAdminList(userId: number): number | undefined {
    return this.getAdminIds().find(adminId => adminId === userId);
  }

  getAdminIds(): number[] {
    const AdminIds = this.admins.map(member => member.id);
    return AdminIds;
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  onOk(): void {
    if (this.formValidate()) {
      this.$emit('onOk', this.userId);
      this.$refs.formRef.reset();
      this.onCancel();
    }
  }

  onCancel(): void {
    this.$refs.formRef.reset();
    this.$refs.menuRef.closeMenu();
  }

  openMenu(): void {
    this.$refs.menuRef.openMenu();
  }
}
